import { useMutation } from "@apollo/client"
import { REMOVE_USER_ACCOUNT } from "../graphql/mutations/removeUserAccount"

export const useRemoveUserAccount = ({ onCompleted, onError }: { onCompleted: any; onError: any }) => {
  const [removeUserAccount, { client, data, loading }] = useMutation(REMOVE_USER_ACCOUNT, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [],
  })

  return { removeUserAccount, data, loading, client }
}
